import React, { ReactElement } from 'react';

import { Route } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import { HPMSOnRenderAction } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { FetchAPI, InlineImage } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { ConsultaHistoricoAlteracaoCadastralAliases as Aliases } from '../codegen';

import BaseController from './BaseController';

interface Data {
  cdPessoaFisica: string,
  nrSeqBeneficiario: number,
}

@Controller({ fragment: 'consulta-historico-alteracao-cadastral' })
class ConsultaHistoricoAltCadastral extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    const params = {
      dtInicio: null,
      dtFim: null,
    };

    FilterService.restoreFilterState(event, params);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnBeforeFetch({ target: 'fetch-consulta' })
  onBeforeFetch(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

  @HPMSOnRenderAction('hpms-custom-card')
  onRenderActionCustomCard(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSeqBeneficiario, cdPessoaFisica } = data as Data;
    const content = (): ReactElement => (
      <InlineImage
        className="u-hpms-clickable"
        src="/static/assets/view-details.svg"
        onClick={() => this.detalhes(nrSeqBeneficiario, cdPessoaFisica)}
      />
    );

    render(content);
  }

  private detalhes = (nrSeqBeneficiario: number, cdPessoaFisica: string): void => {
    this.historyService.push(Route.BENEFICIARY_DATA_DETALHES, { cdPessoaFisica, nrSeqBeneficiario });
  };

}
export default ConsultaHistoricoAltCadastral;
